/**
 * Credential-bearing auth/session fields that Bugsnag must redact wherever
 * they appear in browser or server metadata. Keep both common casing styles:
 * future Redis/refresh adapters may use internal camelCase fields while
 * upstream OAuth payloads use snake_case. The source list is readonly; each
 * Bugsnag configuration receives its own mutable copy so an SDK cannot mutate
 * the shared policy used by the other runtime.
 */
export const AUTH_REDACTED_KEYS = [
  'authorization',
  'cookie',
  'set-cookie',
  'access_token',
  'accessToken',
  'refresh_token',
  'refreshToken',
  'code',
  'code_verifier',
  'codeVerifier',
  'code_challenge',
  'codeChallenge',
  'state',
  'interaction_token',
  'interactionToken',
  'resume_token',
  'resumeToken',
  'magic_link_token',
  'magicLinkToken',
  'reset_token',
  'resetToken',
  'password',
  'passwordConfirmation',
  'retype_password',
  'email',
  'client_secret',
  'clientSecret',
  'session_id',
  'sessionId',
  'redis_session_id',
  'redisSessionId',
  'session_key',
  'sessionKey',
  'lock_value',
  'lockValue',
  'lock_token',
  'lockToken',
  'encryption_key',
  'encryptionKey',
  'kek',
  'root',
  'roots',
  'PENZU_LOCAL_KEY_ROOTS',
  'wrappedKey',
  'dataKey',
  'ciphertext',
] as const;
